<template>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" :fill="backgroundColor"/>
    <path d="M20.1276 11.5996V27.4654" :stroke="textColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M23.7334 14.4844H18.3246C17.6551 14.4844 17.0131 14.7503 16.5398 15.2237C16.0664 15.697 15.8005 16.339 15.8005 17.0085C15.8005 17.6779 16.0664 18.3199 16.5398 18.7933C17.0131 19.2666 17.6551 19.5326 18.3246 19.5326H21.9304C22.5999 19.5326 23.2419 19.7985 23.7152 20.2719C24.1886 20.7452 24.4545 21.3872 24.4545 22.0567C24.4545 22.7261 24.1886 23.3681 23.7152 23.8415C23.2419 24.3148 22.5999 24.5808 21.9304 24.5808H15.8005" :stroke="textColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
export default {
    props: {
        textColor: {
            type: String,
            default: "#A1A8B8",
            required: false,
        },
        backgroundColor: {
            type: String,
            default: "#F0F5FA",
            required: false,
        },
    }
}
</script>